export {default} from './TimeAgo';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/TimeAgo/index.ts